/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { PolicyPageStoryContent } from '../types/policy-page'

export const cookiePolicyFallback: StoryData<PolicyPageStoryContent> = {
  name: 'Cookie Policy',
  created_at: '2023-02-16T11:31:04.464Z',
  published_at: '2026-04-15T13:02:42.327Z',
  id: 262053036,
  uuid: '085f4cf4-9697-4dcd-aca7-565bffe0224f',
  content: {
    _uid: '64be0768-6623-4a56-863c-53ffdf1856d1',
    body: { type: 'doc', content: [{ type: 'paragraph' }] },
    title: 'Cookie Policy',
    clauses: [],
    component: 'PolicyPage',
    cookiePolicy: [
      {
        _uid: '2483b594-d174-4c96-9284-0a923c3ee7b1',
        intro: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Last updated: 14 April 2026',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We use cookies to make our websites more user-friendly or enable them to work effectively on your machine. A cookie is a small file, which will be placed on your device. Find out about the main types of cookies we use and what we use them for below. If you want to know how to delete cookies, go to our deleting cookies section. ',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Some cookies are essential to ensure the security of our sites, to allow you to log in to your account, and to provide functionality such as adding a car into your basket. These cookies are set automatically when you visit the site.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We will always give you the chance to accept or decline non-essential cookies beyond the choice you make when you first see our cookie banner.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'The data we collect using cookies helps us understand our customers better to provide a more focused user experience. Using the knowledge of your previous visits to our website, cinch can enhance subsequent visits by tailoring our content to match your requirements. ',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We also work with advertisers, publishers and social media sites to provide relevant information and content to you. In addition to cookies, if you give us consent we also use web beacons, web tags and tracking pixels. If we share personal data with other parties, we encrypt the personal data to keep it secure and prevent unauthorised use by anyone else. ',
                  type: 'text',
                },
              ],
            },
          ],
        },
        title: '',
        content: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'This button allows you to change your cookie preferences on the website only. If you are using the cinch app, you can change your preferences using the settings under My profile.',
                  type: 'text',
                  marks: [
                    { type: 'bold' },
                    { type: 'styled', attrs: { class: '' } },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: ' ',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'If you’re using the cinch app',
                  type: 'text',
                  marks: [
                    { type: 'bold' },
                    { type: 'styled', attrs: { class: '' } },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'In addition to the cookies listed on this page, we use the following technologies on our app:',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Datadog – essential monitoring of the app performance and usage',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Adobe - general analytics',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: '•          Segment - marketing analytics',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'We’ll always ask permission before setting non-essential cookies, but you are also able to update your preferences at any time by visiting the Settings in the app itself. Please note the ‘Edit Cookie Preferences’ button below is just for cookies set by the main website on your browser, so doesn’t update the app.  ',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            { type: 'paragraph' },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Updating this notice',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'This Cookie Policy may change from time to time due to developments in technology or business, new services or when any legal guidance is published.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: ' ',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'heading',
              attrs: { level: 4 },
              content: [
                {
                  text: 'Cookies used on the cinch site',
                  type: 'text',
                  marks: [{ type: 'styled', attrs: { class: '' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'The cookies listed below are used on our site.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'CookiePolicySection',
        buttonText: 'Edit Cookie Preferences',
        tableSection: [
          {
            _uid: '2c40cae7-5619-43ba-8dc0-581666348d3e',
            table: {
              tbody: [
                {
                  _uid: '',
                  body: [
                    {
                      _uid: 'cff4b036-b8c0-4532-8dc6-19a79cd133c3',
                      value: 'cinch-recently-viewed-cars',
                      component: '_table_col',
                    },
                    {
                      _uid: '803cbb1c-ef94-48d8-86ed-d46708e85d73',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '965300e6-1320-468b-9b78-7c11772c89a3',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '15c4b6ac-00a0-4898-8c12-e7e0ce75a4eb',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ac9d0526-615d-4746-817b-f9a0b1d872fd',
                      value: 'Stores the ids of the vehicles a user has seen.',
                      component: '_table_col',
                    },
                    {
                      _uid: '16e3470d-cda4-449a-a638-2ba5b7137fad',
                      value: '14 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8195d2dc-0a80-4c3e-9dd4-49518199b91a',
                  body: [
                    {
                      _uid: '0d2aa78a-5964-4272-86ab-2c22a9949e9e',
                      value: '__cf_bm',
                      component: '_table_col',
                    },
                    {
                      _uid: '5e787a83-02b7-4300-9200-7e6547a7038a',
                      value: 'Cloudflare',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c27f1ab6-663a-46bf-8108-9f9c7310793f',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e2dd2676-d4aa-4f9d-a76a-350cdad61a0e',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5ebc8397-92cc-44ac-bf8b-73389b25de72',
                      value: 'Cloudflare cookie to protect website from bots.',
                      component: '_table_col',
                    },
                    {
                      _uid: '19b87834-e5e3-4cbb-a213-1c619e7a9a71',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '418cb74c-46a7-48b8-bf58-3bedf945eff3',
                  body: [
                    {
                      _uid: 'd7087359-c758-44f4-bcb3-845bea5196c1',
                      value: '_dd_s',
                      component: '_table_col',
                    },
                    {
                      _uid: '790fc77a-8a64-4727-8105-efea5dae8c7c',
                      value: 'Datadog',
                      component: '_table_col',
                    },
                    {
                      _uid: '2a07cffa-cf33-48d8-880a-b1facf22306a',
                      value: 'https://www.datadoghq.com/legal/privacy/',
                      component: '_table_col',
                    },
                    {
                      _uid: '83529f34-52f4-4f31-aaea-1938a2617bc8',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '56a12299-3ae2-4a92-be2c-56f001edf1e5',
                      value: 'DataDog cookie - Error handling',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f688637d-96a8-408b-b5db-b997a2e20844',
                      value: '15 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '3f413479-ee69-494d-ae49-9647e2400a57',
                  body: [
                    {
                      _uid: '690d63a3-27c2-4dc1-84ff-e2eec24bdd53',
                      value: 'auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '62f71f0b-51fe-46cf-a28c-e6270e095a61',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '70fa579a-aed7-4e55-9966-2bcd3e3bf1ef',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd323c37f-a77e-4df6-ac3a-1c093f9ff7bf',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '25c5ebfc-773c-4367-bcba-694b7c9d87cb',
                      value: 'Used to implement the Auth0 session layer.',
                      component: '_table_col',
                    },
                    {
                      _uid: '3054046e-e31a-4845-981d-40a523311bed',
                      value: '3 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '369641cf-95ec-471c-bae5-e4fcab246b7f',
                  body: [
                    {
                      _uid: '204c1ff6-5ff1-43c4-a24e-523cbb2fec58',
                      value: 'auth0_compat',
                      component: '_table_col',
                    },
                    {
                      _uid: '1ffb3a8d-e5da-4ad8-bcab-b64631003b64',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: '9e2f7c38-bd2b-457a-85f6-9b73be585279',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a6546a96-4246-449c-a6b3-b6e88879127b',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dcdebacd-0d85-498b-8701-f66fc0d36ac6',
                      value:
                        "Fallback cookie used for single sing-on browsers that don't support the sameSite=None attribute",
                      component: '_table_col',
                    },
                    {
                      _uid: '9b5e8c87-52e2-428b-9743-4318dcf59c5b',
                      value: '3 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'b0b29c58-02f5-4b1e-9e68-755d72c654a1',
                  body: [
                    {
                      _uid: 'e253610a-5945-44a8-b46c-032a5ba8dae1',
                      value: 'cp',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dcc8679b-5dc3-4554-ae9f-ef0457764d9e',
                      value: 'cinch',
                      component: '_table_col',
                    },
                    {
                      _uid: '8457da1c-c421-488e-92c7-fc7c17fd704c',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6f84c92f-8cda-4bf8-9ffa-545e43c059d8',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'edf2e959-542d-4686-af3b-c9b2f3cbba8e',
                      value:
                        "Internal cookie - used to store a user's cookie preferences",
                      component: '_table_col',
                    },
                    {
                      _uid: '72a13004-fd70-474e-8935-1cc446af12a3',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'cc8b255d-dfe3-412e-8c25-e589af8bb136',
                  body: [
                    {
                      _uid: 'c3889182-0f41-4cc3-9e82-2a720db14902',
                      value: 'did',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fcd4ed28-3b61-4ecc-a910-4a5f0b95b528',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c59486c3-4a54-4649-b103-96e0295a0cec',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '9cfcea2c-0d64-4628-bbac-3eac804f498a',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '19ed5146-5abb-453c-a947-9e605fd20962',
                      value: 'Device identification for attack protection.',
                      component: '_table_col',
                    },
                    {
                      _uid: '7cdf0031-b0c5-468c-81a0-1f5b9febd1d1',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '40b3cd94-0583-4a99-8c04-f1e6c19d1481',
                  body: [
                    {
                      _uid: 'be3394ad-9a32-41d6-9fb1-79c284c555ae',
                      value: 'did_compat',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b2899468-0656-4b2c-9c48-0ad5f4be55fb',
                      value: 'Auth0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f1f31164-e436-4c4e-9324-be5cfc039947',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '4d06edd4-78c7-41c9-bef4-0d6173905038',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '0fb8901b-99d5-43c6-9b10-3ccd38dfdd75',
                      value:
                        "Fallback cookie for anomaly detection on browsers that don't support the sameSite=None attribute.",
                      component: '_table_col',
                    },
                    {
                      _uid: '656ea037-3312-4903-9acb-5d0e1c49830c',
                      value: '1 year',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '0cc8a02d-ebb4-4d23-8925-fbbc02c2ac59',
                  body: [
                    {
                      _uid: 'f1c3104b-cb97-4a58-b004-03b1df1e127e',
                      value: 'tracking-preferences',
                      component: '_table_col',
                    },
                    {
                      _uid: '8c71a218-6105-46fb-b4c6-b32255308f00',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dc6dd31a-5b2e-4745-9c74-b52f57b84f29',
                      value: 'https://www.twilio.com/legal/privacy',
                      component: '_table_col',
                    },
                    {
                      _uid: '518aae6e-90f0-4d47-a44b-bdca8249483c',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'db7645c1-1ff8-4aa2-8004-d5d4b4cfcece',
                      value:
                        "Segment cookie used to store a user's tracking preferences",
                      component: '_table_col',
                    },
                    {
                      _uid: '58705933-5044-4e46-a33c-e8aac70e9ef4',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '48cd24a8-30ea-47cc-a6ed-01b805a833c7',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: '7433cca8-6c74-4f38-a76b-5646098f5427',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '39ac4d24-69ca-4bb8-83dc-ef916db40fdb',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: '8eca302d-b827-4d6c-8876-3a73b4fcdd6b',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: '4df22beb-d329-448e-b682-611778180ffe',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'c98132ae-e784-4355-8b89-c77aae2fec71',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Essential',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'We use browser cookies that are necessary for the site to work as intended. For example, to store your website data collection preferences so we can honour them if you return to our site, to allow you to log in to your account, and to provide services you have requested, such as ensuring rewards/cashback sites can recognise a sale has occurred. You can disable these cookies in your browser settings but if you do the site may not work as intended.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: false,
          },
          {
            _uid: '4abb4c43-0f35-4a7b-bb29-888fea973731',
            table: {
              tbody: [
                {
                  _uid: 'ede38b50-47e7-4249-8f2e-d8c51d8e85c9',
                  body: [
                    {
                      _uid: 'f404f8ff-4b00-46f9-bb3b-4c8b8d63bef4',
                      value: '__adal_ses',
                      component: '_table_col',
                    },
                    {
                      _uid: '36309c2b-adc4-4cd9-8997-7451737b56fb',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '8341207b-d127-4ccd-855a-e2c85f41d407',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '1a7db30e-168b-4e35-b9eb-bd0ed45abb53',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bc2686f3-a8da-4355-862c-1fc85870a38f',
                      value:
                        'Determines whether there is an active session and which conversions have taken place in this session to prevent duplicates, stores a list of events in this session.',
                      component: '_table_col',
                    },
                    {
                      _uid: '5635ca6c-f60d-47b1-8990-d04b9d1d2bdf',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '53da12d9-477d-4362-b77c-a67b9189683e',
                  body: [
                    {
                      _uid: '070aa455-cc65-47fb-98d5-51e27a5aecd5',
                      value: '__ps_did',
                      component: '_table_col',
                    },
                    {
                      _uid: '00f9ac3d-7568-440a-8db6-fb786ee81e5a',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: 'baf47359-8daf-499c-88bf-0288f7d8f4c2',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '29796557-d812-48f7-9bf5-a3f9f2d1178f',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '9b749269-bd04-41b6-b3fe-5ac67f1378ba',
                      value:
                        'Stores a unique anonymous device ID (pscrb_\u003CUUID\u003E). Used to recognize returning browsers for analytics and attribution.',
                      component: '_table_col',
                    },
                    {
                      _uid: '2302e608-fc06-4826-a52a-cec7bfae5d11',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '2a0602d1-3182-4014-b8a5-890473a6fc3c',
                  body: [
                    {
                      _uid: 'f15a5df7-970f-49da-9d14-5c31e700cbb0',
                      value: '__ps_fva',
                      component: '_table_col',
                    },
                    {
                      _uid: '0019dda7-97d8-481c-b8d0-cb69a316edc1',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: '8773d52f-1229-48bc-b52a-6cc532ebf417',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '7f6f542b-5955-4d26-aeda-49244f74530b',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8efc2406-ad60-48cc-ac98-07e4acdf06df',
                      value:
                        'Stores the timestamp (in milliseconds) of the first visit. Used to measure customer journey duration and return frequency.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e7a403f9-0baf-480e-a1da-382753141f9b',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'e82d9af8-19d4-4a89-9fb7-cdb8cd358c90',
                  body: [
                    {
                      _uid: '92519cc4-214a-47d5-810c-aec8d4f90e51',
                      value: '__ps_lu',
                      component: '_table_col',
                    },
                    {
                      _uid: '9141d812-c8e0-47ea-aa1d-f2f9d5fcb404',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: '3fc109f0-63b1-424f-b9e3-b290c6bc56ab',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c42ac4a0-1cde-48a8-a663-78ab2688d0bb',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3b318d29-4cf8-4606-9bbd-c39cd6c065f6',
                      value:
                        'Stores the first landing page URL where the user entered the site. Used for attribution and analytics.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dccf243c-2fc1-4e7d-a3f2-1b1d5a2fc6f7',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '42176c93-a0d0-432d-9236-6d10cf885858',
                  body: [
                    {
                      _uid: 'a45b4f56-173c-4148-863f-df0dc6ec78ac',
                      value: '__ps_r',
                      component: '_table_col',
                    },
                    {
                      _uid: '4b529189-945a-4a1b-b196-68da1265dd5d',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a9a24e13-645a-4331-a78c-a699205af9db',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '0b5b66ac-7a40-4619-ad6b-e72d6c00363b',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '144e75ac-783d-494d-a96f-fadea1e3dcae',
                      value:
                        'Stores the first referrer URL (the original source that brought the user to the site). Used for first-touch attribution.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ece7551b-7aeb-4dbb-b354-398b0a6a6a3a',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c734bee4-b3ff-4003-86e3-2473def35440',
                  body: [
                    {
                      _uid: '830b192c-9bdc-4e40-8037-af2482f31d41',
                      value: '__ps_sr',
                      component: '_table_col',
                    },
                    {
                      _uid: '5d49420f-0d7b-45eb-9e05-5d8daa653e66',
                      value: 'Podscribe (Podible Inc.)',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cbc46660-5073-4616-9406-cd92af27b126',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '3bfe9e44-accb-4da1-8b4b-d81e9b99a950',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '769952de-f0be-43ba-8ca7-28db85818767',
                      value:
                        'Stores the session referrer for the current browsing session. Used for session-level attribution.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fa443421-99f3-4e45-874e-44986e97eddb',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c6fa0956-5c0f-4cc8-8910-a7f6d78924b8',
                  body: [
                    {
                      _uid: '7658d029-e34b-4e39-af40-002029c945fe',
                      value: '_ga_P06Z9MC4SZ',
                      component: '_table_col',
                    },
                    {
                      _uid: '93199d70-0fb7-4342-8d15-1f28c3358483',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '2a37b7a1-b30e-47c2-ba7e-28970c5fdaec',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '5fb19bd8-185b-4cf9-967c-69a7545187e5',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '2b9d414e-1e0d-44a3-a9b7-7b1e55185c48',
                      value:
                        'Google Analytics cookie used to persist session state.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e2575188-d356-4c27-aa57-a29605915f29',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '17db0459-4196-4002-bec3-7bac801731c4',
                  body: [
                    {
                      _uid: '6e4b4373-b3fd-41a5-a6e8-b45f7fd5f178',
                      value: '_tt_enable_cookie',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e134fe32-1fca-4f08-8e90-eaef3b7753a4',
                      value: 'Tiktok',
                      component: '_table_col',
                    },
                    {
                      _uid: '78fd03bb-bfb4-4599-aaa1-a67b04c6caf4',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '99d519e4-753a-4326-9e8a-c9d4bc7443c6',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cdcf742e-89eb-4496-9aee-b44da6c31af5',
                      value:
                        'This cookie is used as a means of tracking your website activity to help us optimise our advertising',
                      component: '_table_col',
                    },
                    {
                      _uid: '55670e8d-dd5f-4e13-8c00-8f653f770f49',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4e2e68e7-f3c9-44fc-97e4-6eb91b758dd4',
                  body: [
                    {
                      _uid: '443b3db9-1d5f-4544-8fb7-406d96e1cc5a',
                      value: 'everest_g_v2',
                      component: '_table_col',
                    },
                    {
                      _uid: '6d0ec549-3ac7-40e6-9570-76d4ffda50ae',
                      value: 'everesttech.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '5607fc00-4c04-48e6-a6c0-67c6ae617757',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6f2ede25-9572-4616-a4b8-27430ac21c51',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '58f3f26e-e488-4aa8-abf1-ed47960755a9',
                      value:
                        'Used for targeted ads and to document efficacy of each individual ad .',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e4365e98-e196-45f4-b3b0-09894a689e5d',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '1af6a71b-2f28-4292-bacc-46a588a1b0f7',
                  body: [
                    {
                      _uid: 'fce76a55-ba47-4edd-ba16-23e686174b82',
                      value: 'MUID',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a7b027f9-f20e-4325-ae0e-eb08897a56f8',
                      value: 'Bing',
                      component: '_table_col',
                    },
                    {
                      _uid: '8dbb20e4-b139-4ea8-a30f-1fb409eb4110',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e7765d49-8553-4bfa-83ab-c5bd34441437',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '72e944b0-9d2a-4480-a2a8-599125f5d13b',
                      value:
                        'From cinch cookie policy: Set by Microsoft as a unique user ID. Enables user tracking by synchronising the ID across many Microsoft domains.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ac9cfb55-7f0c-48a3-9673-7cbdf09e66c3',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '94c57383-d0de-43a3-a94f-a35460d6e097',
                  body: [
                    {
                      _uid: '45259ad7-4e91-4f00-b50e-126c477594b8',
                      value: '_fbp',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c7d0ce7e-e00d-47d9-9ecb-cd9a0beeda38',
                      value: 'Facebook',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cd4f9ddc-b47b-4006-aab4-389b36ce8f9c',
                      value:
                        'https://www.facebook.com/legal/EU_data_transfer_addendum',
                      component: '_table_col',
                    },
                    {
                      _uid: '3f3f90d6-6ec9-47cb-bdbe-b48fccb99ff0',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dd15c50d-c489-4331-9fe9-a5889edeb577',
                      value:
                        'Used by facebook to track visits across the website.',
                      component: '_table_col',
                    },
                    {
                      _uid: '37865616-a683-43f9-925e-2c79f35240c5',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'cd2c31c2-f060-44d4-b174-fcd4a6ebcc7d',
                  body: [
                    {
                      _uid: '79ff4845-f66c-404c-9cbc-8465f52d712a',
                      value: '_ga',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c079c6b3-e11c-4c05-916d-e9e32957fd9b',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f6189d27-1f54-47a7-b644-85dfd1eb3d17',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c0505e4e-929c-4d05-ae67-b2682259d580',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '20302dca-cf1c-4132-bd94-39f304c4a36b',
                      value:
                        'Google Analytics cookie used to distinguish users.',
                      component: '_table_col',
                    },
                    {
                      _uid: '2bac5b8f-6689-4648-b0dc-c1613831793f',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7275cfba-d44d-4ab6-93ea-d7b0a97bc170',
                  body: [
                    {
                      _uid: '5487d70f-b211-40bd-b843-69d68d78da57',
                      value: '_ttp',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd4696773-4bba-49fe-8214-21ae7a091604',
                      value: 'TikTok',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c59a812c-4b1b-4144-98a6-d9559045e2f9',
                      value: 'https://ads.tiktok.com/help/article?aid=10007540',
                      component: '_table_col',
                    },
                    {
                      _uid: '088226cc-f737-4d78-aada-fb62ef830dd1',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f52513b8-41f3-472a-83d8-acbb9eeb594c',
                      value:
                        "To measure and improve the performance of your advertising campaigns and to personalize the user's experience (including ads) on TikTok",
                      component: '_table_col',
                    },
                    {
                      _uid: 'def09f0a-1727-4938-9f8b-9d888bfe37bb',
                      value: '13 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7adedfce-a057-43bb-85a3-8384f9d1193d',
                  body: [
                    {
                      _uid: 'c807d22c-efac-4986-a25c-82e36b5f54d6',
                      value: '_uetvid',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cbea3767-1721-429d-a53e-6e82f6270444',
                      value: 'Bing',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f1305714-92ff-47a3-88da-a8bac9de596a',
                      value:
                        'https://cookiedatabase.org/cookie/bing-ads/_uetvid/',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f4b14410-9290-471d-8b16-ad287965316f',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '43e5d4d0-7543-41c7-8566-7de4b9f406dd',
                      value: 'to store and track visits across websites.',
                      component: '_table_col',
                    },
                    {
                      _uid: '485216b8-bd6c-4ef1-be3f-b564d13def76',
                      value: 'Maximum of 16 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '104dd88e-2b8e-476d-a64c-00fc7a3abb45',
                  body: [
                    {
                      _uid: 'a82203b1-b514-4645-9e72-e3928dbc9c04',
                      value: 'ad-id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f97350ba-3f99-4dbd-85eb-500e6b5e6ba8',
                      value: 'Amazon',
                      component: '_table_col',
                    },
                    {
                      _uid: '1df3834d-b5fc-4a64-aebe-49d64a6280fc',
                      value:
                        'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e1ac2408-eb67-4548-99c9-21c44cde96aa',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '41417e01-45f9-412d-af8e-5b396329546f',
                      value:
                        'Used by Amazon Advertising to record user actions and target website content based on ad clicks on a different website',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e1906b90-6ef5-4b9b-911e-952ea2e183e9',
                      value: '13 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'f4e16f3e-4efe-4384-a0f3-f55ee17b80c1',
                  body: [
                    {
                      _uid: 'fc0fcad0-ab91-4136-83e6-6fe511660620',
                      value: 'ad-privacy',
                      component: '_table_col',
                    },
                    {
                      _uid: '03ab3036-e3d5-4e6d-8844-7ca22b2cc688',
                      value: 'Amazon',
                      component: '_table_col',
                    },
                    {
                      _uid: '186887fb-06a5-4f96-a5a8-f7c81c25cf24',
                      value:
                        'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ba9d1add-6c89-470a-a32d-a13077db431c',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '450667db-e0f3-4b90-a30e-25f7427b4027',
                      value:
                        'The cookie is used by Amazon Advertising to manage opt-outs',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd9fc32cd-0b43-4c4a-9ae3-878ccbc6c065',
                      value: '5 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7dcddaa4-a1c5-444b-a2bf-e2d6f3aebcc7',
                  body: [
                    {
                      _uid: 'aadaa1d2-447f-4b57-96b4-1c1cf4999caf',
                      value: 'ajs_anonymous_id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fc5c9ae0-b7d5-4320-aa51-41a99c2d4ff1',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: '10ba9033-7db7-434b-a7b6-57f3bf319674',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '3b2d5fbe-e0c1-4552-a1b8-3a0c4a4c9674',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '59970a46-6cd7-4b40-b368-6b164b23fdd8',
                      value:
                        'Used by Segment to anonymously correlate user sessions',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd959e77c-7d1f-4e43-8dda-7494fa74d950',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'fc4356e1-2fa7-4606-80c5-d9da8064a26b',
                  body: [
                    {
                      _uid: 'a3974113-9997-4610-ba51-84925091d358',
                      value: 'ajs_user_id',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ca6d8d4f-0fd6-4fb5-abb9-841c27ae85ea',
                      value: 'Segment',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1d25ffb-7cbd-45dc-b118-d09420f58275',
                      value:
                        'https://privacy.microsoft.com/en-GB/privacystatement',
                      component: '_table_col',
                    },
                    {
                      _uid: '631b9994-1cf6-45f4-8e13-80b82be1cfc3',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'af435a74-ee99-4159-800a-3091be6b540e',
                      value:
                        'Used by Segment to link anonymous ID with cinch userID',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b2de6063-7c98-4f98-af8b-4c27b7192e97',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '49f3cb87-e669-4834-a3b0-f9e77c68f778',
                  body: [
                    {
                      _uid: '546500ca-c21d-4422-abce-ba544c7a33ea',
                      value: 'receive-cookie-deprecation',
                      component: '_table_col',
                    },
                    {
                      _uid: 'df72857a-e731-41f0-ad91-b2031ea9601d',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c5ff4085-3948-4900-bd63-e1b011e4b35d',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '69650e73-777a-4f83-99d7-02c0588986b9',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '4060c933-4e31-4edb-bb12-e9cc204845da',
                      value:
                        'Google sets this cookie to enable Privacy Sandbox testing and preview how site behaviour and functionality work without third-party cookies.',
                      component: '_table_col',
                    },
                    {
                      _uid: '43c358e2-d06f-4def-8f56-d06cacaff582',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '83156732-2671-4f58-847b-2d20eeb1b24f',
                  body: [
                    {
                      _uid: '4e3ff306-884e-4249-b555-72f1873b6c10',
                      value: 'ttcsid',
                      component: '_table_col',
                    },
                    {
                      _uid: '85134fa4-aaec-4551-bdf1-a6819d71e3ca',
                      value: 'Tiktok',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ff06dda0-29a4-4603-8558-c149add79f42',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '12d808a4-d42a-453c-a8f7-9f667ab9c5be',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e72dd414-efc7-4bb5-bd23-9b510b49927d',
                      value:
                        'Description found online: This cookie is essential for maintaining user sessions and ensuring core site functionality.',
                      component: '_table_col',
                    },
                    {
                      _uid: '072b8895-3e6e-4553-8afc-61ae029246ce',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '60aab365-cd84-451a-94aa-abeb49d576dc',
                  body: [
                    {
                      _uid: '4f28e6ab-25b3-4f7e-9db0-3d6a498209c1',
                      value: 'ttcsid_C7EL8KCRNSL79GUTBST0',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e130dbfd-60bd-43a4-9b51-e6fe4c31a5a7',
                      value: 'Tiktok',
                      component: '_table_col',
                    },
                    {
                      _uid: '9f8dd22a-b741-4886-9838-37c573c1954e',
                      value:
                        'https://www.tiktok.com/legal/privacy-policy-eea?lang=en',
                      component: '_table_col',
                    },
                    {
                      _uid: '2ea87ef2-41e4-4b62-83ba-85b9b1f06eab',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3f51329f-58d2-4b82-977a-9645d90f5c76',
                      value:
                        'The TikTok cookie ttcsid likely serves as a session identifier, helping to maintain user sessions and track interactions across the platform.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c1b979f0-548d-4a5a-b05b-fd0f72aa0c39',
                      value: '365 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9bb24a5a-6687-4ada-93e7-77bd92284246',
                  body: [
                    {
                      _uid: '53a8dc5c-6bf0-4c1a-86af-8ca30a428b35',
                      value: '__adal_ca',
                      component: '_table_col',
                    },
                    {
                      _uid: 'caa7d91d-d564-42e0-b23f-b790bee2d58b',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a224d49c-60ce-4d7f-9399-dae58606fd96',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '6a21d331-a96f-48a5-9f1b-ce147256cbe9',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f73d4e9a-0bee-4610-ac9e-121a722069cf',
                      value:
                        'Stores which advertising campaign drove a user to visit, stores traffic source and campaign data.',
                      component: '_table_col',
                    },
                    {
                      _uid: '9cd0eaa1-e1a0-46f6-9692-6da54a15cb09',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '304f5d2c-d0d9-4db5-a8e9-94301cdc5e35',
                  body: [
                    {
                      _uid: '28240870-b5a9-4de6-ba48-fdcd0a97d442',
                      value: '__adal_cw',
                      component: '_table_col',
                    },
                    {
                      _uid: '111dcbac-fba2-4eba-9633-e745bf863958',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: '90a1fb36-c9b5-4879-b0b0-ce08ecc9ccf1',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '710dac50-7863-4d6a-8e6e-c3ca38aeee52',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '0960d33c-4d31-4d81-bfa1-7c0548fc9230',
                      value:
                        'Ties back conversion events to earlier visits, stores a visit timestamp.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f38404fd-970b-4bfe-a5b3-3917c5090895',
                      value: '7 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4e1f5c7f-fc31-4204-a19b-4e032b755c34',
                  body: [
                    {
                      _uid: '4c78819c-8e4e-40e8-91f0-e40a9adb4899',
                      value: '__adal_id',
                      component: '_table_col',
                    },
                    {
                      _uid: '6da36b9b-3bbf-4ab5-aafe-df1b3fb19251',
                      value: 'Adalyser (OneSoon)',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b4533449-d274-46c4-b98c-2458ce8a16c3',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd9ca6ae9-b0fd-483b-94a7-53afdfcc3d02',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '6d834a1b-7257-493f-a3ab-9c290dabb0ea',
                      value:
                        'Uniquely identify a device, stores a generated Device ID.',
                      component: '_table_col',
                    },
                    {
                      _uid: '5046aa8d-6a36-4c08-aadc-95d23f1e7349',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9d45573e-a8d9-4ec3-a12b-a1f76ffb63e2',
                  body: [
                    {
                      _uid: '32e31911-6609-4f32-b8d8-2b902eb11337',
                      value: '_fbc',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fefac122-bdaf-4cff-85a8-f9d473201e47',
                      value: 'Facebook',
                      component: '_table_col',
                    },
                    {
                      _uid: '8bd77f9f-c33f-4ccf-b832-297c05dfcca4',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c198d3af-1e50-4f6c-8e1e-b465b7a980bd',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '1a5a21d3-43c8-4757-81ab-7e346be9b240',
                      value:
                        'The "_fbc" cookie is used by Facebook and stores information about your last visit to this website.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a3020014-4ae5-4ef6-9168-d088bd3400df',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4f78b22e-d013-470d-8062-77448eb399e2',
                  body: [
                    {
                      _uid: '1b7d2234-a58f-4824-96e8-6247b7176ccb',
                      value: '_gcl_au',
                      component: '_table_col',
                    },
                    {
                      _uid: '8b55c82d-9bc3-4af0-b608-941904ccaa34',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '8409384f-9d3e-4fb0-90b0-0e220136cdce',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '1bfaa77f-aafd-4e74-9cba-03c72ddc1ecd',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd4a84144-d3c5-45f6-80dd-ec13c157b111',
                      value: 'Link Google advertisements to conversions made.',
                      component: '_table_col',
                    },
                    {
                      _uid: '305f4e09-08c0-4d34-bbf6-e4eb2d27a26f',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '2e0ccba2-6eb9-4225-b977-de5271a6971f',
                  body: [
                    {
                      _uid: '08d7cab0-c7e2-49e0-8e41-3626699d26dd',
                      value: 'APC',
                      component: '_table_col',
                    },
                    {
                      _uid: 'befe0ad4-6388-45b7-8100-6ba83457130e',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '79cbffab-94f2-40b2-b938-a75e0310769c',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c6892ece-7404-4d18-9160-c806765aba65',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '0b7a2163-0594-4a36-ad17-887c01351339',
                      value:
                        'Google cookie used for advertising and security purposes',
                      component: '_table_col',
                    },
                    {
                      _uid: '3fbc683e-12aa-42cb-ba25-ef0f2d96179f',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '6d3b07f1-d971-46f1-ac77-3f307cc87dcf',
                  body: [
                    {
                      _uid: '8e1f8a90-7b35-481e-a536-06e10854fc1c',
                      value: 'ar_debug',
                      component: '_table_col',
                    },
                    {
                      _uid: '0ebbe2bd-8d91-4b22-b2d7-72592e236830',
                      value: 'doubleclick.net',
                      component: '_table_col',
                    },
                    {
                      _uid: '1f4fc4f9-dcfc-41ad-bc8a-27d10dd7a4dc',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '35730ffb-7506-4950-9352-3d607bc14425',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7ebedbf7-4d20-4ee0-bc07-974c376ff983',
                      value:
                        'DoubleClick sets this cookie to debug and troubleshoot the ads served by DoubleClick.',
                      component: '_table_col',
                    },
                    {
                      _uid: '7582efab-95bb-4ac4-8bd4-bcd423c451df',
                      value: '90 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'd56c204d-6603-43de-85a1-fc4c3281b2fa',
                  body: [
                    {
                      _uid: '711370d2-365c-4677-ab23-7e52c985620d',
                      value: 'DV',
                      component: '_table_col',
                    },
                    {
                      _uid: '26e39722-8d4c-4ae9-963d-2bbc81bc37c0',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '665413c1-a02f-4d70-a472-3ecc938fac36',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bad99cd3-8c51-4293-9887-397956931f96',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ca6ea845-a5a9-49f6-9dc6-54a440c6ec7b',
                      value:
                        'cookie used to collect website statistics and track conversions and google ads',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cc46448b-2735-45cd-a3eb-98183dfb2280',
                      value: '0',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'd6746bbc-9fa4-4925-b707-26ca66661500',
                  body: [
                    {
                      _uid: '843b9a9c-8a83-4744-bbad-dc4d073da821',
                      value: 'IDE',
                      component: '_table_col',
                    },
                    {
                      _uid: '0eeccbaf-2ac6-4477-80e5-5f1d6c144772',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: '4af93ff5-4c2c-4e8c-b8f9-b766ad955513',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '46deecf9-f1fe-4d1d-9bb6-dfa9a25e0aad',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '3114fdb4-aad5-4e60-b2eb-cade623b6150',
                      value:
                        'Third-party cookie set by Google’s DoubleClick platform, used for serving targeted advertisements that are relevant to you across the web',
                      component: '_table_col',
                    },
                    {
                      _uid: '9bb9284c-4e53-4c44-ab7f-1f8accc5d5eb',
                      value: '390 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '563ecbd0-7b45-4b25-9a60-8ead1bf8eb51',
                  body: [
                    {
                      _uid: 'e974a3ee-3b76-428c-90dc-43c7ff7523a4',
                      value: 'NID',
                      component: '_table_col',
                    },
                    {
                      _uid: '922efee5-f8b1-407d-8076-69e045325a33',
                      value: 'Google',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ddcde3cd-8332-490f-a725-14e68593a027',
                      value:
                        'https://policies.google.com/technologies/partner-sites',
                      component: '_table_col',
                    },
                    {
                      _uid: '2e392f72-25d6-47a3-80b2-724150590df6',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '7b58b583-d097-4d66-bd26-60c3c67c1cf1',
                      value:
                        'cookie used to collect website statistics and track conversions and google ads',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ea069723-576d-4248-9347-bb789c5081a2',
                      value: '6 months',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '1c08a3a4-cd06-4325-80c0-9fd32bbb1e7b',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: '97ca4297-a6ed-4223-8425-4523633f266e',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: '01a1bda3-47dc-49ba-b123-a1df9de62881',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: 'e54d1ec7-69cb-4a5e-b1a4-de909bc4d5e6',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: 'c9f573b2-67a6-48c8-ae1b-6d9c7806a7c1',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'c184274c-7b0c-4338-8892-5f91057bcacd',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Advertising and Targeting',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',

                  content: [
                    {
                      text: 'To personalise and measure the effectiveness of advertising on our site and other websites.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',

                  content: [
                    {
                      text: 'Accepting advertising means your data (including anonymous IDs or other encrypted identifiers) may be shared with the third parties specified below. We also use technologies such as web beacons and tracking pixels to allow this to happen. ',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: true,
          },
          {
            _uid: 'b4c5c3c3-43d1-43b1-ad4a-0ef7ce763d47',
            table: {
              tbody: [
                {
                  _uid: 'd670f306-d045-457b-a3cc-b248ef7fde4f',
                  body: [
                    {
                      _uid: '5b1cd178-30ba-48e9-87c5-abada33092c1',
                      value: 'demdex',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fa3651ff-68b3-44ff-8e8d-62c4d8380afb',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c2de32b6-60c7-4432-ba81-5eac505200b0',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '20ee103e-6153-44c5-a6aa-648615c5e615',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '972942dc-e73d-4abc-bf6a-114219cd9ed4',
                      value:
                        "Via a unique ID that is used for semantic content analysis, the user's navigation on the website is registered and linked to offline data from surveys and similar registrations to display targeted ads.",
                      component: '_table_col',
                    },
                    {
                      _uid: '80854268-9abb-4a32-aa5e-780ad19ee681',
                      value: '180 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '8e537289-0e35-47ef-8b85-289d66fa6040',
                  body: [
                    {
                      _uid: '68b2bcb3-034d-443d-bb6b-e029030a19ae',
                      value: 'dpm',
                      component: '_table_col',
                    },
                    {
                      _uid: '6f0f48af-49b2-49e5-be18-4c33a8d78a79',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '8112bfbe-965b-48e6-b3c7-f9c2936252eb',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '3e2462f4-1012-4396-8b5c-eef1deb1b30c',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '20ef36a1-5466-4e65-9455-72716669e826',
                      value:
                        "Via a unique ID that is used for semantic content analysis, the user's navigation on the website is registered and linked to offline data from surveys and similar registrations to display targeted ads.",
                      component: '_table_col',
                    },
                    {
                      _uid: '71176849-fdd3-42c3-a330-0af2a6387a78',
                      value: '180 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '4b46a9d9-3c78-47c4-a733-879c96fa9695',
                  body: [
                    {
                      _uid: 'c6757498-bafa-486a-912d-8bc884316429',
                      value: 'AMCV_E5F2C8A15481C0E20A4C98BC%40AdobeOrg',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f36c9c40-dbb0-4f25-a4ad-9846fd7bf20e',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '87599270-2125-4d21-a4bf-46ad737285aa',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '4da713d7-1b04-4575-beab-9a7ffe30348d',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'caadae1b-3663-4461-80ba-6a528ba41596',
                      value:
                        'Contains a visitor ID in order for Adobe Analytics to understand behaviour across cinch.co.uk.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'a1b86a0d-4db5-4b48-b0ec-6a700bcfa8df',
                      value: '400 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'b601f761-2baf-4aab-bdb1-d98cb2611ecf',
                  body: [
                    {
                      _uid: '9242b5d6-b564-4a80-8f57-9df1ce5c16d9',
                      value: 'AMCVS_E5F2C8A15481C0E20A4C98BC%40AdobeOrg',
                      component: '_table_col',
                    },
                    {
                      _uid: '26255759-0409-4539-8afc-4d39cfa18f02',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '812077f0-25d5-447c-a205-60601dad4fd9',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fd9d8bf8-d02b-41d3-bbe5-5752202b4f92',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '5af121ad-aa46-4bf3-a0f6-4787e653f275',
                      value:
                        'Counts the number of vists of a visitor to cinch.co.uk.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dbf66de6-2803-4daa-915b-2127343edde1',
                      value: 'End of session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'e3eacfe5-3a82-4d44-ba51-651d167fcc25',
                  body: [
                    {
                      _uid: '5ced19ee-6254-4b6d-89ee-3f60260115d9',
                      value: 'at_check',
                      component: '_table_col',
                    },
                    {
                      _uid: '5f4ab836-fe3a-4f60-b1e5-df6703afa5a4',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fed88c6c-696d-4da5-89d7-1d18d4be1109',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c4485a31-1fb8-4619-bcd5-027ccc473aee',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'dd580949-f4cd-4542-bd88-4276dc0af339',
                      value:
                        'Cookie policy: Determines if the visitor supports cookies or not. Adobe documentation: Temporary cookie to check if the cookie read/write capability is enabled on the browser.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f040ab83-4cf5-480b-9fa8-fe412961213a',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '765922ba-d66d-4bbd-a28a-d995e16ffa3e',
                  body: [
                    {
                      _uid: '6c9a08a6-a4c3-47dd-aafa-f5b3600b6381',
                      value:
                        'com.adobe.reactor.core.visitorTracking.pagesViewed',
                      component: '_table_col',
                    },
                    {
                      _uid: '515cf1ee-8905-46f6-a2e5-3384638b6a77',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ad460aa2-1438-4e28-b905-3052018d476e',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c4c02105-58a2-406c-99fc-c2e6cde56d40',
                      value: '3rd Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '8d4ea847-86df-48a5-83b0-34762000f167',
                      value:
                        'Contains data on user navigation, interaction and time spent on the website and its sub-pages - This data is used to optimise the relevance of advertisements and for statistical purposes.',
                      component: '_table_col',
                    },
                    {
                      _uid: '2f88028f-3868-4e5c-81e3-7053e748098a',
                      value: 'localStorage',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'b8fa801b-1f76-4c31-8ace-f242793f2798',
                  body: [
                    {
                      _uid: '310bb7f0-b093-4bc3-864f-0c4662c22541',
                      value: 'mbox',
                      component: '_table_col',
                    },
                    {
                      _uid: '66b8c737-b7a9-4633-a146-e455cf0c0945',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '15f04775-59e7-452a-be64-db93d548cbd3',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '663f3bf2-1cbe-4813-9d3b-70810606adf6',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '518a3119-7fa9-4894-a25d-4f73bfb6e6c8',
                      value:
                        'Adobe Target cookie - Test to see which content is more relevant to visitors.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cc1204f3-2e2d-4392-86c8-b3d77f2b9f2b',
                      value: '2 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'c0ce4ee7-ee26-4be2-b448-438b2ffb5a41',
                  body: [
                    {
                      _uid: 'a0e0d84d-8060-4df3-b972-f290cc926f51',
                      value: 'mboxEdgeCluster',
                      component: '_table_col',
                    },
                    {
                      _uid: '4767c19e-2eb1-4561-8711-1bf024c2f0f1',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '54af10aa-4711-4e06-8818-8075c3d613fc',
                      value: '',
                      component: '_table_col',
                    },
                    {
                      _uid: '86f9723c-6ab0-4fe3-a89c-c6d67f9c92fa',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ba4afe91-f612-47a2-a564-8f39e511637e',
                      value: 'Adobe Target cookie',
                      component: '_table_col',
                    },
                    {
                      _uid: '4cc33431-7db5-4dd4-becd-9869b5f46821',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '7ed65f59-afea-4fa0-bb2f-8abd1e4e5360',
                  body: [
                    {
                      _uid: '05f67232-2f66-4def-8deb-686d2465c5c5',
                      value: 's_cc',
                      component: '_table_col',
                    },
                    {
                      _uid: '0136d853-3b07-4528-a9e6-ef330fcc98b9',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '48870457-4521-44f5-a735-ab7c8a3852a9',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '32b9b871-0c20-454e-a327-8045323d9fc3',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '132b1620-e50a-4540-8947-c8b3a1ab471d',
                      value:
                        'This cookie is set and read by the JavaScript code to determine if cookies are enabled (set to “True”).',
                      component: '_table_col',
                    },
                    {
                      _uid: 'b26d2347-3063-4be8-ac8f-56ea1fe073be',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'ccace78b-c1e1-47c0-b462-348f23859dc5',
                  body: [
                    {
                      _uid: 'd67946ab-91e7-4a16-8824-7e3b804750d5',
                      value: 's_getNewRepeat',
                      component: '_table_col',
                    },
                    {
                      _uid: '048d2087-cbe3-4e13-a35b-ff420b65f58a',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '8a620ca5-d460-4dd3-b7e3-677597d71d7a',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: 'fffaa9da-ff4a-4be2-8c84-e68367469d5f',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e2164a92-7484-4549-92bc-48cacfde0102',
                      value:
                        'Determine whether a visitor to the site is a new visitor or a repeat visitor within a desired number of days',
                      component: '_table_col',
                    },
                    {
                      _uid: 'e4f53f89-ca59-41f4-8ce5-2db471fc4c4a',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '679c2be1-03ef-49f8-96c4-19bdcea98bbe',
                  body: [
                    {
                      _uid: 'b9b238ab-f176-4359-b0ea-2dd903b3d8a7',
                      value: 's_invisit',
                      component: '_table_col',
                    },
                    {
                      _uid: '40de6450-e54a-481d-846b-947960620fa3',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '97b3b094-c663-4638-ad12-142f24134f96',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '5d45ce18-3631-4517-95f1-4c1af8cc9c39',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c7838952-213f-4e1e-ae33-00ce7db260ce',
                      value:
                        'Determines whether the user is visiting the page for the first time',
                      component: '_table_col',
                    },
                    {
                      _uid: 'bdd95348-54df-4c4f-a7e0-f4fe91b6f644',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'a7eb82aa-1143-4ec6-ae12-68c4bc375e39',
                  body: [
                    {
                      _uid: '1e72e002-059c-42ff-8040-0f432671ddf9',
                      value: 's_ppn',
                      component: '_table_col',
                    },
                    {
                      _uid: '5e9a82fa-f367-4697-a75f-368253600755',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '60e691f1-5c90-46e6-877d-93f03995c167',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '51437f99-fab5-4523-9760-1464ae449550',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'd255481a-977f-4550-816d-6f118ecc7d76',
                      value:
                        'Retrieves the previous page name to support the s_ppv cookie plugin',
                      component: '_table_col',
                    },
                    {
                      _uid: '93e22796-c45c-43f8-b9eb-591c1ceddcea',
                      value: '1 hour',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '282e6d5f-53f8-4fd0-8b9c-1e1461fd197a',
                  body: [
                    {
                      _uid: 'f2a307a3-272f-4985-8d63-c6c85d4f8ae8',
                      value: 's_sq',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f80b46cf-9dac-4e84-ae26-894868019765',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ca1b4255-c6a0-4913-90ee-ec7d19bbb981',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '99d59d30-57fc-4907-91d4-fe6f96e419ed',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'ef4366b8-defb-4d96-84c4-6afdb277edda',
                      value:
                        'This cookie is set and read by the JavaScript code when the SelectMap functionality or the Activity Map functionality are enabled; it contains information about the previous link that was selected on by the user.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f83c2c34-18d3-4ca6-bc3b-f23fef597745',
                      value: 'Session',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '9da4d35c-06c0-4125-bc44-7f776bae4d58',
                  body: [
                    {
                      _uid: 'b33d92ae-87fb-4392-aabe-4e9afc546332',
                      value: 's_vnum',
                      component: '_table_col',
                    },
                    {
                      _uid: '1cd23647-eaa0-4896-99fd-5f1c3a8a2924',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: 'c465d1f6-6fe7-4564-8d00-3ed4c90ae264',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '70855b8f-17c7-483c-99d8-2f482452a3ff',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '1930c4d2-0207-4dc7-9147-55647b85f4cc',
                      value: 'Stores the number of visits by a Unique Visitor.',
                      component: '_table_col',
                    },
                    {
                      _uid: 'f92e5d12-0543-496c-8e12-e11cc3882e10',
                      value: '30 days',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: 'fa272ea3-0b97-43ae-b4da-48d803cb03c9',
                  body: [
                    {
                      _uid: 'f1a06393-6542-4b38-a7f7-616b1a7bebcd',
                      value: 'sc_dslv',
                      component: '_table_col',
                    },
                    {
                      _uid: '2d0fd5ad-316b-4771-95db-778822abd2b7',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '34f4e8ab-939a-4551-8ad0-cda4c89fff71',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '48670a3a-d81a-4d41-a2f1-83d13e094620',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: '78ead188-2097-46ea-8f8f-e6efd3a74f5b',
                      value:
                        'Determines the number of days since a user last visited your site, and captures this information in an Analytics variable.',
                      component: '_table_col',
                    },
                    {
                      _uid: '6085ee24-bb15-4759-a573-88460b5536f9',
                      value: '3 years',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
                {
                  _uid: '5d3206cc-0f73-4863-aeb9-d090305c7899',
                  body: [
                    {
                      _uid: 'ed4511cd-378f-4749-90b4-1ac20575dfcc',
                      value: 'sc_dslv_s',
                      component: '_table_col',
                    },
                    {
                      _uid: '88bd108a-4c7d-4023-b2c7-82f8a7e88a40',
                      value: 'Adobe',
                      component: '_table_col',
                    },
                    {
                      _uid: '4c8ca663-3029-46a2-859b-ef5c2ae3a190',
                      value:
                        'https://www.adobe.com/privacy/experience-cloud.html',
                      component: '_table_col',
                    },
                    {
                      _uid: '95258014-b0e1-48ff-b39e-4113d3fb898a',
                      value: '1st Party',
                      component: '_table_col',
                    },
                    {
                      _uid: 'cbaf105a-afff-4a13-9056-1b1ba397512a',
                      value:
                        'Determines the number of days since a user last visited your site, and captures this information in an Analytics variable.',
                      component: '_table_col',
                    },
                    {
                      _uid: '5b33c0b5-3f59-4cf5-8715-138566f0895e',
                      value: '30 minutes',
                      component: '_table_col',
                    },
                  ],
                  component: '_table_row',
                },
              ],
              thead: [
                {
                  _uid: '189be6c4-11d9-4b01-bf9f-7015d39ea38a',
                  value: 'Cookie ID',
                  component: '_table_head',
                },
                {
                  _uid: '37c4ed66-f09a-4be8-8adc-67df18d621ba',
                  value: 'Company Name',
                  component: '_table_head',
                },
                {
                  _uid: 'e41a6910-a7df-464d-bcde-3fef0a3d2f0a',
                  value: 'Link',
                  component: '_table_head',
                },
                {
                  _uid: '15a7896f-5d9b-40cc-bf10-19d32ac78b90',
                  value: '1st Party or 3rd Party',
                  component: '_table_head',
                },
                {
                  _uid: '42c7d9cc-2008-4437-84ee-b407254f8a51',
                  value: 'Use',
                  component: '_table_head',
                },
                {
                  _uid: 'cd5cf263-a605-4510-9c7c-1b79c0a6d9d7',
                  value: 'Lifespan',
                  component: '_table_head',
                },
              ],
              fieldtype: 'table',
            },
            heading: 'Analytics (statistical)',
            component: 'TableSection',
            description: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',

                  content: [
                    {
                      text: 'These cookies are on by default and help us understand how visitors use our site. They collect pure statistical anonymous data on page views, traffic sources, and user interactions so we can measure performance and improve the overall experience.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            dontShowTableHeader: true,
          },
        ],
        deleteSection: [
          {
            _uid: '630ac524-809c-44df-bb86-70580899cc65',
            title: 'Deleting cookies',
            pcNote: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'text',
                      text: 'You may update your cookie preferences at any time and they will be deactivated on your device. If you wish to delete the cookies manually, you can do this via your browser Privacy settings. If you are using the cinch app, you can delete browsing data including cookies by using the Storage or App settings on your device.',
                    },
                  ],
                },
              ],
            },
            macNote: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'text',
                      text: '',
                    },
                  ],
                },
              ],
            },
            component: 'DeleteCookiesSection',
            pcInstructions: [],
            macInstructions: [],
          },
        ],
      },
    ],
  },
  slug: 'cookie-policy',
  full_slug: 'policies/cookie-policy',
  sort_by_date: null,
  position: -160,
  tag_list: [],
  is_startpage: false,
  parent_id: 170758273,
  meta_data: null,
  group_id: '3ef71527-4b3b-4c97-aa8e-a12516cae039',
  first_published_at: '2022-08-05T14:35:58.000Z',
  lang: 'default',
  path: '',
  alternates: [],
}
